import { API_REQUEST_FAIL_WITH_STATUS } from 'store/types';

export const apiRequestFailedStatuses = [
    { statusCode: 500, callback: (dispatch, url, statusCode) => dispatch({ type: API_REQUEST_FAIL_WITH_STATUS, payload: { message: 'Something wrong on server side', url, statusCode }  })},
    { statusCode: 503, callback: (dispatch, url, statusCode) => dispatch({ type: API_REQUEST_FAIL_WITH_STATUS, payload: { message: 'You don\'t have permission to do that', url, statusCode }  })},
];